export enum DefaultFilterTypeKey {
   ContractsOverview = 'contracts-overview',
   PerformancesOverview = 'performances-overview',
}

export interface DefaultFilterType {
   id: number;
   key: DefaultFilterTypeKey;
}
